export default {
  rankOrder: {
    ariaAddOption: 'Agregar {label} a la lista ordenada',
    ariaMoveUp: 'Mover {label} arriba',
    ariaMoveDown: 'Mover {label} abajo',
    ariaRemoveOption: 'Eliminar {label} de la lista ordenada',
  },
  coe: {
    ariaDisclaimer: 'Aviso',
    ariaQuestion: 'Pregunta',
    ariaConversationHistory: 'Historial de conversación',
    ariaYourResponse: 'Tu respuesta {number}',
    ariaFollowUpQuestion: 'Pregunta de seguimiento {number}',
    ariaResponseInput: 'Campo de respuesta',
    ariaRespondingTo: 'Respondiendo a',
    ariaSendResponse: 'Enviar respuesta',
    ariaThinking: 'Pensando'
  },
  deviceView: {
    toolbar: 'Dispositivo de vista previa',
    mobile: 'Móvil',
    tablet: 'Tableta',
    desktop: 'Escritorio'
  },
  header: {
    customLogoAlt: 'Logotipo',
    defaultLogoAlt: 'Logotipo de QuestDIY'
  }
}
